import { useState, useEffect } from 'react';
import apiClient from '../../../apiClient';
import useUser from '../../../customHooks/useUser';

export default function useStationInfo () {
    
    const { user } = useUser();
    const { s_unit, s_email } = user;
    const [stationInfo, setStationInfo] = useState({});

    useEffect(() => {
        const resolveCorpStationInfo = async () => {
            const res = await apiClient.get(`/resolveCorpStationInfo?s_unit=${s_unit}`);
            setStationInfo(res.data);
        }
        if (s_unit) {
            resolveCorpStationInfo();
        }
    }, [s_unit, s_email]);

    return stationInfo;
}